import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: flex;
	align-items: center;
	column-gap: 20px;

	img {
		width: 20px;
		height: 20px;
		opacity: 0.75;
		user-select: none;
		pointer-events: none;
	}

	${Text} {
		font-weight: 400;
		font-size: 16px;
		color: #ffffff;
		opacity: 0.75;
	}
`;

export { StyledContainer };
